module.exports = __webpack_public_path__ + "img/idx-service-itembg.14d6b0f.webp";